import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GeneralCatalogSelectService } from '../general-catalog-select.service';

export interface TypeOfDaySelectOption {
  value: string;
  label: string;
  code?: string;
}

/** Catálogo `period_span` vía select unificado. */
@Injectable({ providedIn: 'root' })
export class TypeOfDaySelectService {
  private readonly generalCatalogSelect = inject(GeneralCatalogSelectService);

  getOptions(): Observable<TypeOfDaySelectOption[]> {
    return this.generalCatalogSelect.getListOptionsByPrefix('period_span').pipe(
      map((options) =>
        options.map((o) => ({
          value: o.value,
          label: o.label,
          code: o.code || '',
        })),
      ),
    );
  }
}
